<template>
  <span class="wrapper" :class="{ error }">
    <input
      type="text"
      :value="value"
      :disabled="disabled"
      :readonly="readonly"
      @change="$emit('change',$event.target.value)"
      @input="$emit('input',$event.target.value)"
      @focus="$emit('focus',$event.target.value)"
      @blur="$emit('blur',$event.target.value)"
    />
    <template v-if="error">
      <k-icon name="error" class="icon-error"></k-icon>
      <span class="errorMessage">{{ error }}</span>
    </template>
  </span>
</template>

<script>
import Icon from "../button/icon";
export default {
  name: "KilokInput",
  components: {
    'k-icon': Icon,
  },
  props: {
    value: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
$height: 32px;
$border-color: #999;
$border-color-hover: #666;
$font-size: 12px;
$box-shadow-color: rgba(0, 0, 0, 0.5);
$red:#F1453D;
.wrapper {
  font-size: $font-size;
  display: inline-flex;
  margin-top:5px;
  align-items: center;
  &:not(:last-child) {margin-right:.5em}
  > :not(:last-child) {margin-right:.5em}
  > input { height: $height; border: 1px solid $border-color; border-radius: 4px; padding: 0px 8px; font-size: inherit;
    &:hover { border-color: $border-color-hover; }
    &:focus { box-shadow: inset 0 1px 3px $box-shadow-color; outline: none; }
    &[disabled],
    &[readonly] { border-color: #bbb; color: #bbb; cursor: not-allowed; }
  }
  &.error {
    > input { border-color:$red; } }
  .icon-error { fill:$red; }
  .errorMessage{ color:$red; } }
</style>
